import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Briefcase, Users, ClipboardText, CheckCircle, Plus, Warning } from "@phosphor-icons/react";
import StatusBadge from "@/components/StatusBadge";

export default function CompanyDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/company/dashboard").then((r) => setS(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="label-caps">Company console</div>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Overview</h1>
        </div>
        <div className="flex gap-2">
          {s && <StatusBadge status={s.company_status} />}
          <Link to="/company/jobs/new" data-testid="header-create-job-btn"><Button className="bg-blue-600 hover:bg-blue-700 h-11 px-5"><Plus size={16} className="mr-1.5"/> Create job</Button></Link>
          <Link to="/company/jobs/bulk" data-testid="header-bulk-jobs-btn"><Button variant="outline" className="h-11">Bulk import</Button></Link>
        </div>
      </div>
      {s?.company_status === "pending_approval" && (
        <div className="flex items-start gap-3 p-4 bg-yellow-50 border border-yellow-200 rounded-md">
          <Warning size={20} className="text-yellow-700 mt-0.5" />
          <div>
            <div className="font-semibold text-slate-900">Awaiting admin approval</div>
            <div className="text-sm text-slate-700">You can create draft jobs — publishing is available once you're approved.</div>
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Card icon={Briefcase} label="Active jobs" value={s?.active_jobs ?? 0} />
        <Card icon={Users} label="Open positions" value={s?.open_positions ?? 0} />
        <Card icon={ClipboardText} label="Confirmed staff" value={s?.confirmed_staff ?? 0} />
        <Card icon={CheckCircle} label="Completed" value={s?.completed_shifts ?? 0} />
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        <Link to="/company/jobs" className="card-tactile p-5">
          <div className="label-caps text-blue-600">Manage</div>
          <div className="font-display text-xl font-bold mt-1">My jobs</div>
        </Link>
        <Link to="/company/bookings" className="card-tactile p-5">
          <div className="label-caps text-blue-600">Workforce</div>
          <div className="font-display text-xl font-bold mt-1">Bookings & attendance</div>
        </Link>
        <Link to="/company/profile" className="card-tactile p-5">
          <div className="label-caps text-blue-600">Business</div>
          <div className="font-display text-xl font-bold mt-1">Company profile</div>
        </Link>
      </div>
    </div>
  );
}

function Card({ icon: I, label, value }) {
  return (
    <div className="card-tactile p-4">
      <I size={20} className="text-blue-600 mb-2" />
      <div className="label-caps">{label}</div>
      <div className="font-display text-2xl font-extrabold text-slate-900">{value}</div>
    </div>
  );
}
